import React from "react";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";
import { bindActionCreators } from "redux";
import { forEach, size } from "lodash";

import { getUserOrganizations } from "../../actions/resourceActions";
import {TouchCheckbox, TouchNumber} from "../../AtollonTheme/ReactElements";
import * as InstanceRoles from "../../Atollon/Instance/InstanceRoles";

const options = [
  { label: "Přístupné", value: "related" },
  { label: "Vlastněné", value: "owned" },
  { label: "Mnou spravované", value: "administered" }
];

const Filter = ( props ) => {

    let { getUserOrganizations, dispatch, state } = props;

    let choices = [];
    forEach( options, (item, index) =>
    {
        const name = item.label;
        const value = item.value;
        const type = value;
        const id = "instance_filter_" + name;
        const uniqueReactKey = index;
        const isChecked = state.resource.myAtollon_selectedUserOrganizationTypeName === type;
        const count = InstanceRoles.getCount( state, type );
        const backgroundColor = InstanceRoles.getBackgroundColor( type );

        choices.push((
            <span key={uniqueReactKey} className="touchCheckboxWithLabel-spaceBetween">
                <TouchCheckbox
                    label={
                        <div className="touchCheckboxWithLabel-labelPadding">
                            <div className="touchCheckboxWithLabel-label">{name}</div>
                            <TouchNumber text={count} className="touchCheckboxWithLabel-TouchNumber" style={{ backgroundColor }}/>
                        </div>
                    }
                    id={id}
                    name="requestTypes"
                    checked={isChecked}
                    onChange={boolean => {
                        console.log( 'xxxfilter3', value );
                        getUserOrganizations(value,true);
                    }}
                />
            </span>
        ));
    });
    console.log( {choices});

  return (
    <div className="instanceList-filter flex-row flex-centered">
        {choices}
    </div>
  );
};

export default compose(
    connect(
        ( state ) => { return { state }},
        ( dispatch ) =>
        {
            return {
                getUserOrganizations: bindActionCreators( getUserOrganizations, dispatch ),
                dispatch
            }

        }
    ),
    lifecycle({
        componentWillMount()
        {
            let { getUserOrganizations } = this.props;

            forEach( options, ( item ) =>
            {
                const instanceType = item.value;
                getUserOrganizations( instanceType );
            });
        }
    })
)(Filter);



// WEBPACK FOOTER //
// ./src/components/organizations/Filter.js